// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"668":"afeb0c0d","948":"f0077ec4"}[chunkId] + ".chunk.css";
};